import React from "react";
import PropTypes from "prop-types";
import { Label } from "reactstrap";

const InstaLabel = props => (
  <Label
    className={"insta-label " + props.className}
    title={props.toolTip}
    data-toggle="tooltip"
    data-placement="bottom"
  >
    <span dangerouslySetInnerHTML={{ __html: props.title }}></span>
    <sup className={props.required === true ? "asterisk" : "d-none"}>*</sup>
  </Label>
);

export default InstaLabel;

InstaLabel.defaultProps = {
  title: "Submit",
  className: ""
};

InstaLabel.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string
};
